import "./App.css";

import Home from "./components/Home";

function App() {
  return (
    <div className="app ">
      <Home />
    </div>
  );
}

export default App;
